/*
 * Built with Common Launchpad 2.0.3
 */

import Vue from 'vue';
import Fragment from 'vue-fragment';
import VeeValidate from 'vee-validate';
import { TooltipPlugin, AlertPlugin, CollapsePlugin, ModalPlugin } from 'bootstrap-vue';  // ui plugins
import store from '../../store/web-qualifier-tool';

Vue.use(Fragment.Plugin);

// init ui plugins add/remove as needed
Vue.use(AlertPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);
Vue.use(ModalPlugin);

Vue.use(VeeValidate, {
	events: 'change|blur',
	inject: true,
    errorBagName: 'vErrors',	
});

// init app
const VueApp = new Vue({
    store
});

export { VueApp as default };